import React from 'react';
import { formatCycle, groupPlansByCycle } from '../utils';
import { PlanCard } from './PlanCard';

export function PlanCardsGrid({ plans, selectedIds, onToggleSelected }) {
  const groups = groupPlansByCycle(plans);

  return (
    <>
      {groups.map((group) => (
        <div key={group.cycleDays} className="mb-6">
          <h3 className="jds-title-sm mb-4">
            {formatCycle(group.cycleDays)}
          </h3>
          <div className="row">
            {group.plans.map((plan) => (
              <div key={plan.id} className="col-md-6 col-lg-4 mb-6">
                <PlanCard
                  plan={plan}
                  selected={selectedIds.includes(plan.id)}
                  onToggleSelected={onToggleSelected}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
